import axios from '@/util/axios';
import Address from '@/store/models/Address';

const state = {
	addressToValidateId: <string> '',
	validatedAddresses: <Address[]> [],
};

const getters = {
	addressToValidateId: (state: any) => state.addressToValidateId,
	validatedAddresses: (state: any) => state.validatedAddresses,
};

const mutations = {
	updateAddressToValidateId: (state: any, addressToValidateId: string) => state.addressToValidateId = addressToValidateId,
	updateValidatedAddresses: (state: any, validatedAddresses: Address[]) => state.validatedAddresses = validatedAddresses,
};

const actions = {
	async getValidatedAddresses(context: any, address: Address) {
		try {
			const response = await axios.get('Address/Validate', { params: { ...address }});
			context.commit('updateValidatedAddresses', response.data);
		}
		catch (error) {
			context.commit('addErrorMsg', error.toString());
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
